module.exports = __webpack_public_path__ + "static/img/member_bg.bd3b85a8.png";